import React from 'react'

function Footer() {
  return (
    <div className='bg-slate-600 mt-10 rounded-md  '>
      <div className='  '>
         <p className='text-center text-white p-5'>
      © 2023 Copyright: <a href="/">Mahaer</a>
      </p>
      </div>
     
    </div>
  )
}

export default Footer
